<p-overlaybadge
  [value]="value()"
  [severity]="severity()"
  [badgeSize]="badgeSize()"
>
  <ng-content></ng-content>
</p-overlaybadge>
